<template>
    <infobox-generic v-if="responseData.code === 'signed_operation_created'" :label="responseData.data.additionalMessage"/>
    <!-- *********************************************
    *                Contract Data Block             *
    ********************************************** -->
    <container-collapsible removeBorder oneTitleOnly variant="primary" :title="t('bankassurance.subscribe.auto.step6.contractDataTitle')">
        <text-block-generic
        :params="{
            label: t('bankassurance.subscribe.auto.step6.policyNumberLabel'),
            content: responseData.data.policyId || '-'
        }"/>
        <text-block-generic
        :params="{
            label: t('bankassurance.subscribe.auto.step6.productLabel'),
            content: responseData.data.insuranceType || t('bankassurance.subscribe.auto.step6.policyAutoProduct')
        }"/>
        <text-block-generic
        :params="{
            classes: 'capitalize',
            label: t('bankassurance.subscribe.auto.step6.criationDateLabel'),
            content: getDate(responseData.data.policyCreationDate) || '-'
        }"/>
        <text-block-generic
        :params="{
            label: t('bankassurance.subscribe.auto.step6.statusLabel'),
            content: statusContent
        }"
        :icon="statusIcon"
        :colorIcon="statusIconColor"/>

        <div
        v-if="responseData.errorLevel === 'INFO'"
        class="buttons-wrapper"
        :class="{'mobile': getMobileAppState}">
            <!-- Policy Button -->
            <button-tertiary icon="download" :label="'Apólice'" @clicked="downloadLink = createDownloadPolicyUrl(getSimulationData.insuranceId)"/>
            <!-- Other Documents -->
            <button-tertiary
            v-for="document in getDocuments.filter(ele => ele.docType === 'DOCTYPE_RECEIPT' || ele.docType === 'DOCTYPE_GREEN_CARD')"
            icon="download"
            :key="document.documentId"
            :label="document.nameDocType"
            @clicked="downloadLink = createDownloadPolicyDocumentUrl({
                insuranceId: getSimulationData.insuranceId,
                receiptId: document.documentId,
                docType: document.docType
            })"/>
        </div>
    </container-collapsible>
    <!-- *********************************************
    *                     Info Block                 *
    ********************************************** -->
    <container-collapsible oneTitleOnly variant="primary" :title="t('bankassurance.subscribe.auto.step6.infoTitle')" :removeBorder="responseData.errorLevel !== 'WARNING'">
        <text-block-generic
        :params="{
            classes: 'capitalize',
            label: t('bankassurance.subscribe.auto.step6.paymentLabel'),
            content: t('bankassurance.subscribe.auto.step6.paymentValue')
        }"/>
        <text-block-generic
        :params="{
            classes: 'capitalize',
            label: t('bankassurance.subscribe.auto.step6.startDateLabel'),
            content: getDate(formData.dataInicio)
        }"/>
    </container-collapsible>
    <!-- *********************************************
    *                    Driver Block                *
    ********************************************** -->
    <container-collapsible oneTitleOnly variant="primary" :title="t('bankassurance.subscribe.auto.step6.driverTitle')">
        <!-- Name -->
        <text-block-generic
        :params="{
            classes: 'capitalize',
            label: t('bankassurance.subscribe.auto.step6.nameLabel'),
            content: titleCaseBuilder(formData.driverName)
        }"/>
        <!-- Birth Date -->
        <text-block-generic
        :params="{
            classes: 'capitalize',
            label: t('bankassurance.subscribe.auto.step6.birthDateLabel'),
            content: isHolder ? getDate(getHolderData.birthDate) : getDate(formData.birthDate)
        }"/>
        <!-- Civil Status -->
        <text-block-generic
        :params="{
            classes: 'capitalize',
            label: t('bankassurance.subscribe.auto.step6.civilStatusLabel'),
            content: getDomainData('Civil Status').find(ele => ele.code === formData.civilStatus).description
        }"/>
        <!-- Fiscal Identification -->
        <text-block-generic
        :params="{
            classes: 'capitalize',
            label: t('bankassurance.subscribe.auto.step6.fiscalIdentificationLabel'),
            content: formData.fiscalIdentification
        }"/>
        <!-- Identification -->
        <text-block-generic
        :params="{
            classes: 'capitalize',
            label: t('bankassurance.subscribe.auto.step6.identificationLabel'),
            content: formData.identification
        }"/>
        <!-- contact -->
        <text-block-generic
        :params="{
            classes: 'capitalize',
            label: t('bankassurance.subscribe.auto.step6.contactLabel'),
            content: formData.contact
        }"/>
        <!-- mobile -->
        <text-block-generic
        :params="{
            classes: 'capitalize',
            label: t('bankassurance.subscribe.auto.step6.mobileLabel'),
            content: formData.secondaryMobile
        }"/>
        <!-- email -->
        <text-block-generic
        :params="{
            label: t('bankassurance.subscribe.auto.step6.emailLabel'),
            content: formData.email
        }"/>
        <!-- Gender -->
        <text-block-generic
        :params="{
            classes: 'capitalize',
            label: t('bankassurance.subscribe.auto.step6.genderLabel'),
            content:  formData.gender ? getDomainData('Gender').find(ele => ele.code === formData.gender).description : '-'
        }"/>
        <!-- Driver Licence Date -->
        <text-block-generic
        :params="{
            classes: 'capitalize',
            label: t('bankassurance.subscribe.auto.step6.driverLicenceDateLabel'),
            content: getDate(formData.driverLicenceDate)
        }"/>
        <!-- Driver Licence Number -->
        <text-block-generic
        :params="{
            classes: 'capitalize',
            label: t('bankassurance.subscribe.auto.step6.driverLicenceNumberLabel'),
            content: formData.driverLicenceNumber
        }"/>
        <!-- Adress -->
        <text-block-generic
        :params="{
            classes: 'capitalize',
            label: t('bankassurance.subscribe.auto.step6.adressLabel'),
            content: formData.address1
        }"/>
        <!-- Additional Adress -->
        <text-block-generic
        :params="{
            classes: 'capitalize',
            label: t('bankassurance.subscribe.auto.step6.adress2Label'),
            content: formData.address2
        }"/>
        <!-- postalCode -->
        <text-block-generic
        :params="{
            classes: 'capitalize',
            label: t('bankassurance.subscribe.auto.step6.postalCodeLabel'),
            content: getDomainData('Province').find(ele => ele.code === formData.postalCode)?.description
        }"/>
        <!-- province -->
        <text-block-generic
        :params="{
            classes: 'capitalize',
            label: t('bankassurance.subscribe.auto.step6.provinceLabel'),
            content: getDomainData('City').find(ele => ele.code === formData.province).description
        }"/>
        <!-- country -->
        <text-block-generic
        :params="{
            classes: 'capitalize',
            label: t('bankassurance.subscribe.auto.step6.countryLabel'),
            content: getDomainData('AddressCountry').find(ele => ele.code === formData.country).description
        }"/>
    </container-collapsible>
    <!-- *********************************************
    *                    Object Block                *
    ********************************************** -->
    <container-collapsible oneTitleOnly variant="primary" :title="t('bankassurance.subscribe.auto.step6.objectTitle')">
        <!-- Licence Plate -->
        <text-block-generic
        :params="{
            classes: 'capitalize',
            label: t('bankassurance.subscribe.auto.step6.licencePlateLabel'),
            content: formData.matriculaVeiculo
        }"/>
        <!-- First Licence Plate Date -->
        <text-block-generic
        :params="{
            classes: 'capitalize',
            label: t('bankassurance.subscribe.auto.step6.firstLicenceDateLabel'),
            content: getDate(formData.dt1aMatriculaVeiculo)
        }"/>
        <!-- Brand -->
        <text-block-generic
        :params="{
            classes: 'capitalize',
            label: t('bankassurance.subscribe.auto.step6.brandLabel'),
            content: getDomainData('AUTBrand').find(ele => ele.code === formData.marcaVeiculo).description
        }"/>
        <!-- Model -->
        <text-block-generic
        :params="{
            classes: 'capitalize',
            label: t('bankassurance.subscribe.auto.step6.modelLabel'),
            content: getDomainData('AUTModel').find(ele => ele.code === formData.modeloVeiculo).description
        }"/>
        <!-- Categoria -->
        <text-block-generic
        :params="{
            label: t('bankassurance.subscribe.auto.step6.categoryLabel'),
            content: t('bankassurance.subscribe.auto.step6.categoryValue')
        }"/>
        <!--  -->
        <text-block-generic
        :params="{
            label: t('bankassurance.subscribe.auto.step6.cilindradaVeiculoLabel'),
            content: formData.cilindradaVeiculo
        }"/>
    </container-collapsible>
    <!-- *********************************************
    *                    Object Block                *
    ********************************************** -->
    <container-collapsible oneTitleOnly variant="primary" :title="t('bankassurance.subscribe.auto.step6.insuranceTitle')">
        <!-- Package -->
        <text-block-generic
        :params="{
            label: t('bankassurance.subscribe.auto.step6.packageLabel'),
            content: t('bankassurance.subscribe.auto.step6.packageValue')
        }"/>
        <!-- Escalao Capital -->
        <text-block-generic
        :params="{
            label: t('bankassurance.subscribe.auto.step6.escalaoCapitalLabel'),
            content: getDomainData('AUTCapitalCRBAI').find(ele => ele.code === formData.escalaoCapitalRCCoberturas).description
        }"/>
    </container-collapsible>
    <!-- *********************************************
    *                  Insurance Block               *
    ********************************************** -->
    <container-collapsible oneTitleOnly v-if="responseData.errorLevel === 'INFO'" variant="primary" :title="t('bankassurance.subscribe.auto.step6.paymentDataTitle')">
        <text-block-generic
        :params="{
            label: t('bankassurance.subscribe.auto.step6.accountLabel'),
            content: accountFormatHelper(accountsBalances.find(ele => ele.id === formData.originAccount).accountNumber)
        }"/>
        <text-block-generic
        :params="{
            label: t('bankassurance.subscribe.auto.step6.amountLabel'),
            content: amountFormat(getSimulationData.quotation.premium.anualSimulatedValue, getSimulationData.quotation.premium.currency)
        }"/>
    </container-collapsible>
    <!-- Component to handle download logic-->
	<download-logic-component :downloadLink="downloadLink" @clearDownloadLink="downloadLink = null"/>
</template>

<script setup>
import ContainerCollapsible from '@/components/generic/containers/Collapsible'
import TextBlockGeneric from '@/components/generic/textBlocks/Generic'
import InfoboxGeneric from '@/components/generic/infobox/Generic'
import ButtonTertiary from '@/components/generic/buttons/Tertiary'
import DownloadLogicComponent from '@/components/generic/DownloadLogicComponent'

/* Vue */
import { computed, ref } from 'vue'

/* Assets */
import { getDate } from '@/assets/scripts/dateBuilders'
import { amountFormat } from '@/assets/scripts/amounts'
import { accountFormatHelper, titleCaseBuilder } from '@/assets/scripts/strings'
import { iconMapper, iconColorMapper } from '@/assets/scripts/mappers/policies'
import { createDownloadPolicyUrl, createDownloadPolicyDocumentUrl } from '@/network/api/insurance.api.js'

/* Store */
import { mapGetters } from '@/store/helpers/mappers'
import { moduleMapper } from '@/store/helpers/modules.map'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

/* mapActions & mapGetters */
const {	getDomainData, getSimulationData, getDocuments } = mapGetters(moduleMapper.BANKASSURANCE_SUBSCRIBE)
const { getMobileAppState } = mapGetters()

/* props received
@formData { Object } - object with info for our current form
*/
const props = defineProps({
    formData: Object,
    accountsBalances: Array,
    responseData: Object,
    receiptNumber: Number
})

const downloadLink = ref(null)

const statusContent = computed(() => {
    return props.responseData.code === 'signed_operation_created' ? t('bankassurance.subscribe.auto.step6.statusPendingSignature') : props.responseData.data.policyStatus.description
})

const statusIcon = computed(() => {
    return iconMapper(props.responseData.data.policyStatus ? props.responseData.data.policyStatus.name : '')
})

const statusIconColor = computed(() => {
    return `var(--${iconColorMapper(props.responseData.data.policyStatus ? props.responseData.data.policyStatus.name : 'SUSPENDED')})`
})
</script>

<style lang="scss" scoped>
.infobox-generic-wrapper {
    margin-top: 24px;
}

.collapsible-divider-wrapper {
    padding: 0;

    .buttons-wrapper {
        width: 100%;

        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
        gap: 16px;

        .button-tertiary {
            min-width: fit-content;
        }

        &.mobile {
            flex-direction: column;
        }
    }
}
</style>
